export default function PlayIcon({color = "#181818"}) {
    return (
        <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5.5L0.750001 10.2631L0.750001 0.73686L9 5.5Z" fill={color}/>
        </svg>

    )
}